import React, { useCallback, useEffect, useMemo, useState } from 'react'

import {Grid, CircularProgress, Box, Typography} from '@mui/material'
import { useSelector } from 'react-redux'

import useStyles from '../../../styles/global-mui.js';

import { discipline_actu_all } from '../../../bdd/bddSTUB.js'
import Select_Dsas from '../../../dsasComponents/Select_Dsas.js'
import Live from './live/Live.js'
import { fetchCategories, fetchLives } from '../../../api/index.js'
import { getUserProvider, isAdminDSAS } from '../../../actions/auth.js'
import { useFetch } from '../../../filters/useFetch.js'
import FilterGroupProvider from '../../../dsasComponents/FilterGroupProvider.js'
import DatePicker_Dsas from '../../../dsasComponents/DatePicker_Dsas.js'
import { FETCH_ALL_CATEGORY, FETCH_ALL_LIVE } from '../../../constants/actionTypes.js'
import FilterUser from '../../../dsasComponents/FilterUser.js'
import Pagination from '../../../dsasComponents/pagination/Pagination.js'
import { Can } from '../../../permissions/Can.js'
import { PERMISSIONS } from '../../../permissions/permissionKeys.js'
import { usePermissions } from '../../../permissions/usePermissions.js';

const Lives = ( { setCurrentId }) => {
    const classes = useStyles();

    const { getPermission } = usePermissions();
    const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);

    const livesCollection = useSelector((state) => state.lives);

    // FILTERS
    const [filters, setFilters] = useState({discipline : '', category : '', provider : getUserProvider(), startDate : new Date(), endDate : new Date(), actualites : {$ne : []}, userNames: ''})

     // reset user quand le provider change
  useEffect(() => {
    setFilters(state => {
      // si déjà vide, on ne touche à rien pour éviter un set inutile
      if (!state.userNames) return state;
      return { ...state, userNames: '' };
    });
  }, [filters.provider]);
    
    const [lives, loading] = useFetch(fetchLives, filters, ['startDate', 'endDate'], FETCH_ALL_LIVE)
    const [categories, loadingCategories] = useFetch(fetchCategories, filters, undefined, FETCH_ALL_CATEGORY)


    const handleUserFilter = useCallback((user) => {
        return filters.provider === user.provider
    }, [filters.provider])

    const livesNoDoublon = useMemo(() => {
            const livesCollectionFiltered = livesCollection.filter(live => !lives.find(l => l._id === live._id));
            return lives.concat(livesCollectionFiltered);
        }, [livesCollection, lives]);


        const isUserSelected = !!filters.userNames;


    return (
        loading ? <CircularProgress /> : (<>

        {/**FILTERS*/}
                    <Box className='padding-wrapper'>
                        <Grid container spacing={1.5} sx={{alignItems : 'flex-end'}}>
                            {providerPermission?.allowed && ( 
                            <Grid item xs={12} sm={12} md>
                                {/* Groupe (Provider) */}
                                <FilterGroupProvider
                                classname={classes.customInput}
                                labelId = {"provider_label"}
                                label = {"Groupe"}
                                selectId = {"provider"}
                                name = {"provider"}
                                filters = {filters} 
                                setFilters = {setFilters}
                            />             
                            </Grid>
                            )}
                            <Grid item xs={12} sm={12} md>
                                {/* User */}
                                <FilterUser
                                classname={classes.customInput}
                                labelId = {"users_label"}
                                label = {"Utilisateur"}
                                selectId = {"userNames"}
                                name = {"userNames"}
                                filters = {filters} 
                                setFilters = {setFilters}
                                handleFilter = {handleUserFilter}
                                mandatory = {true}
                            />
                            </Grid>
                            <Grid item xs={12} sm={12} md>
                                {/* Discipline */}
                                <Select_Dsas
                                    className={classes.customInput}
                                    labelId = {"discipline_label"}
                                    label = {"Discipline"}
                                    selectId = {"discipline"}
                                    name = {"discipline"}
                                    value = {filters.discipline}
                                    items = {discipline_actu_all}
                                    onChange = {(e) => setFilters(state => ({...state, discipline : e.target.value}))}
                                    onReset = {(e) => setFilters(state => ({...state, discipline : ''}))}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='medium-separator'></Box>
                    <Box className='small-padding'></Box>
                    <Box className='padding-wrapper'>
                        <Grid container spacing={1.5} sx={{alignItems : 'center'}}>
                            <Grid item sx={{justifyItems: 'center'}} xs={12} sm md>
                                {/* Begin date */}
                                <DatePicker_Dsas
                                className={classes.customInput}
                                label={"Début"}
                                name={"startDate"}
                                value={filters.startDate}
                                onChange = {(value) => setFilters(state => ({...state, startDate : value}))}
                                isBorder={false}
                                />             
                            </Grid>
                            <Grid item sx={{justifyItems: 'center'}} xs={12} sm md>
                                {/* End date */}
                                <DatePicker_Dsas
                                className={classes.customInput}
                                label={"Fin"}
                                name={"endDate"}
                                value={filters.endDate}
                                onChange = {(value) => setFilters(state => ({...state, endDate : value}))}
                                isBorder={false}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    
                    <Box className='small-padding'></Box>
                    {!isUserSelected &&
                        <Box className='centered-wrapper medium-padding'>
                        <Typography variant='body2' sx={{ fontStyle: 'italic' }} >Veuillez sélectionner un utilisateur pour lancer la recherche.</Typography>
                        </Box>
                    }
                    <Box className='medium-separator'></Box>
        
                    <Box className='padding-wrapper'>
                        {/**RESULTS*/}
                        {livesNoDoublon?.length>0 && isUserSelected &&
                            <Pagination  items={livesNoDoublon} classes={classes} type='Directs' className={classes.customTablePagination}>
                                {livesNoDoublon.map(live => 
                                    <Live live={live} setCurrentId={setCurrentId} reload={() => setTimeout(() => setFilters({...filters}), 200)}/>
                                )}
                            </Pagination>
                        }
                    </Box>    
        </>
        )
    )
}

export default Lives